$(document).ready(function () {
  if ($('.accordion').length){
    $(".accordion").each(function() {
      console.log('test');
      $(this).closest('.shopify-section').addClass('pricing-accordion-section');
    });
  }
  $.fn.addBack = function (selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
  }
  $(".accordion > .accordion-title").each(function (index) {
    $(this).nextUntil(".accordion .accordion-title").addBack().wrapAll("<div class='accordion-group'></div>");
  });
  if ($('.accordion-content').length){
  } else {
    $('.accordion .accordion-group').each(function (index) {
      $(this).children().not('.accordion-title').wrapAll("<div class='accordion-content'></div>");
    });
    $( ".accordion-group .accordion-title" ).click(function() {
      $(this).next().slideToggle();
      $(this).toggleClass('active');
    });
    $(".accordion-group:first-child .accordion-title").addClass('active');
  } 
  
  
});

